<template>
  <div class="subscription-card expert">
    <h3 class="card-title">{{ $t("offreActuelle") }}</h3>

    <ul class="features">
      <li v-for="(feature, index) in features" :key="index">
        <component :is="feature.icon" class="mr-2" component=""></component>
        {{ feature.text }}
      </li>
    </ul>

  </div>
</template>



<script>
export default {
  name: 'SubscriptionLotsCard',
  props: {
    currentMaxNbLots: {
      type: Number,
      default: 0
    },
    lotsActifs: {
      type: Number,
      default: 0
    },
    currentMaxNbCollaborators: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      icons: {
        operations: 'building-community-icon',
        collaborators: 'users-icon',
      }
    };
  },
  computed: {
    features() {
      return [
        {
          icon: this.icons.operations,
          text: `${this.currentMaxNbLots} Lots max cumulés sur vos opérations en cours`
        },
        {
          icon: this.icons.operations,
          text: `${this.lotsActifs} Lots actifs sur vos opérations en cours`
        },
        {
          icon: this.icons.collaborators,
          text: `${this.currentMaxNbCollaborators} Collaborateurs MDB`
        }
      ];
    }
  }
};
</script>

<style scoped>
.subscription-card {
  background: #fff;
  border-radius: 8px;
  padding: 24px;
  width: 450px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  position: relative; /* Nécessaire pour positionner le bandeau */
  transition: transform 0.3s ease;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.subscription-card:hover {
  transform: translateY(-4px);
}
.subscribed-options ul {
  margin: 8px 0;
  padding-left: 16px;
}
.subscribed-options li {
  font-size: 14px;
}


.current-plan-banner {
  position: absolute;
  top: -15px; /* Décalage pour le chevauchement vertical */
  right: 10px; /* Décalage pour le chevauchement horizontal */
  width: auto; /* Laisse la largeur s'adapter au contenu */
  height: auto; /* S'adapte également au contenu */
  background: var(--main-red); /* Rouge pour le bandeau */
  color: white;
  text-align: center;
  font-weight: bold;
  font-size: 12px;
  padding: 8px 16px; /* Ajoute un padding pour un style agréable */
  border-radius: 4px; /* Ajoute des coins légèrement arrondis */
  z-index: 2;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2); /* Ajoute une ombre pour le contraste */
}


.card-title {
  font-size: 24px;
  font-weight: bold;
}

.card-description {
  font-size: 14px;
}

.features {
  list-style: none;
  padding: 0;
  margin: 8px 0;
}

.features li {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.feature-icon {
}

.subscription-button {
  background: #c41e3a;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 600;
  transition: background-color 0.3s ease;
}

.subscription-button:hover {
  background: #a01830;
}

/* Variantes par type */
.starter {
  background: #f8f9fa;
}

.pro {
  background: rgb(109,132,196);
  color: white;
}

.expert {
  background: rgb(7,21,60);
  color: white;
}

.expert .card-title,
.expert .amount {
  color: white;
}

.expert .subscription-button {
  background: #c41e3a;
}
</style>



// WEBPACK FOOTER //
// src/views/user/components/SubscriptionLotsCard.vue